import { h, render } from 'vue';
import IConfirm from '@/components/ui/i-confirm.vue';

let instance = null;

const showMessage = (options) =>
  new Promise((resolve, reject) => {
    const container = document.createElement('div');

    const destroy = () => {
      if (container) {
        render(null, container); // Unmount the component
        document.body.removeChild(container);
      }
      instance = null;
    };

    const doConfirm = () => {
      destroy();
      resolve();
    };

    const doCancel = () => {
      destroy();
      reject();
    };

    if (!instance) {
      instance = h(IConfirm, {
        ...options,
        doConfirm,
        doCancel,
      });

      // Render the component
      render(instance, container);
      document.body.appendChild(container);
    }
  });

const ConfirmPlugin = {
  install(app) {
    app.config.globalProperties.$confirm = function(options) {
      if (typeof window === 'undefined') {
        return; // Prevent usage on the server
      }

      return showMessage(options);
    };
  },
};

export default ConfirmPlugin;
